module.exports = __webpack_public_path__ + "img/Incorrect.ead3f39b.svg";